import React from "react"
import styled from "styled-components"
import { GlobalStateContext } from "../context/GlobalContextProvider"
import localize from "../localization/localize"

export default function BigSimpleBanner(props) {
  const { title, desc, children } = props
  const state = React.useContext(GlobalStateContext)
  return (
    <Wrapper>
      <TextWrapper>
        <Title>{localize(title, state ? state.lang : "en")}</Title>
        {children}
        <Description>{localize(desc, state ? state.lang : "en")}</Description>
      </TextWrapper>
    </Wrapper>
  )
}

const Title = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 34.1808px;
  line-height: 130%;
  /* identical to box height, or 44px */
  text-align: center;
`

const Description = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 18.242px;
  line-height: 130%;
  /* identical to box height, or 19px */

  text-align: center;

  color: #000000;
`

const Wrapper = styled.div`
  /* width: 100%;
  height: 449px;
  background: #fbfbfd;
  display: grid;
  gap: 20px;
  align-items: center;
  vertical-align: center; */
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  vertical-align: center;
  align-content: center;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  background: #fbfbfd;
`

const TextWrapper = styled.div`
  display: grid;
  gap: 20px;
  padding: 100px 0;
  max-width: 1024px;
  padding-left: 20px;
  padding-right: 20px;
`
